var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "text-h6 my-4 font-weight-black text-uppercase" },
        [_vm._v("Settings")]
      ),
      _c(
        "v-tabs",
        {
          staticClass: "settings",
          attrs: { centered: "", grow: "", "background-color": "primary" },
          model: {
            value: _vm.tabs,
            callback: function ($$v) {
              _vm.tabs = $$v
            },
            expression: "tabs",
          },
        },
        [
          _c("v-tab", { staticClass: "text-left white--text" }, [
            _vm._v("Twilio Settings"),
          ]),
          _c("v-tab", { staticClass: "text-left white--text" }, [
            _vm._v("Phone Numbers"),
          ]),
          _c("v-tab", { staticClass: "text-left white--text" }, [
            _vm._v("Phone Settings"),
          ]),
          _c("v-tab", { staticClass: "text-left white--text" }, [
            _vm._v("Audio Files"),
          ]),
          _c(
            "v-tab-item",
            { staticClass: "py-8 px-4 settings-tab" },
            [
              _c("div", { staticClass: "text-h6 font-weight-bold" }, [
                _vm._v("Twilio Settings"),
              ]),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: { label: "Account SID", outlined: "" },
                                model: {
                                  value: _vm.user.twilio.sid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.user.twilio, "sid", $$v)
                                  },
                                  expression: "user.twilio.sid",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Auth Token",
                                  type: "password",
                                  outlined: "",
                                },
                                model: {
                                  value: _vm.user.twilio.token,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.user.twilio, "token", $$v)
                                  },
                                  expression: "user.twilio.token",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c("v-col", [
                            _vm._v(" API Key: "),
                            _vm.user.twilio &&
                            _vm.user.twilio.apiKey &&
                            _vm.user.twilio.apiKey != ""
                              ? _c("span", { staticClass: "secondary--text" }, [
                                  _vm._v(_vm._s(_vm.user.twilio.apiKey)),
                                ])
                              : _c("span", { staticClass: "secondary--text" }, [
                                  _vm._v("Not set"),
                                ]),
                          ]),
                          _c("v-col", [
                            _vm._v(" Application SID: "),
                            _vm.user.twilio &&
                            _vm.user.twilio.applicationSid &&
                            _vm.user.twilio.applicationSid != ""
                              ? _c("span", { staticClass: "secondary--text" }, [
                                  _vm._v(
                                    _vm._s(_vm.user.twilio.applicationSid)
                                  ),
                                ])
                              : _c("span", { staticClass: "secondary--text" }, [
                                  _vm._v("Not set"),
                                ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-8",
                          attrs: {
                            fluid: "",
                            loading: _vm.is_checking_settings,
                            disabled: _vm.is_checking_settings,
                          },
                          on: { click: _vm.checkTwilioSettings },
                        },
                        [_vm._v("Check Settings")]
                      ),
                      _vm.check_results != null
                        ? _c("div", { staticClass: "pa-4" }, [
                            _c(
                              "div",
                              { staticClass: "ma-1" },
                              [
                                _vm._v(" Twilio SID/Token: "),
                                _vm.check_results.twilio === true
                                  ? _c(
                                      "v-icon",
                                      {
                                        attrs: { small: "", color: "success" },
                                      },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  : _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "error" } },
                                      [_vm._v("mdi-close-circle")]
                                    ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "ma-1" },
                              [
                                _vm._v(" API Key: "),
                                _vm.check_results.api === true
                                  ? _c(
                                      "v-icon",
                                      {
                                        attrs: { small: "", color: "success" },
                                      },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  : _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "error" } },
                                      [_vm._v("mdi-close-circle")]
                                    ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "ma-1" },
                              [
                                _vm._v(" Application SID: "),
                                _vm.check_results.app === true
                                  ? _c(
                                      "v-icon",
                                      {
                                        attrs: { small: "", color: "success" },
                                      },
                                      [_vm._v("mdi-check-circle")]
                                    )
                                  : _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "error" } },
                                      [_vm._v("mdi-close-circle")]
                                    ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _c("v-switch", {
                        attrs: {
                          value: _vm.darkMode,
                          label: `Toggle ${_vm.switchLabel} mode`,
                        },
                        on: { change: _vm.toggleDarkMode },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-tab-item",
            { staticClass: "py-8 px-4 settings-tab" },
            [
              _c(
                "div",
                { staticClass: "text-h6 mb-2 font-weight-bold" },
                [
                  _vm.show_phone == "list"
                    ? _c("span", { staticClass: "mr-2" }, [
                        _vm._v("Phone Numbers"),
                      ])
                    : _vm._e(),
                  _vm.show_phone == "buy"
                    ? _c("span", { staticClass: "mr-2" }, [
                        _vm._v("Buy Phone Number"),
                      ])
                    : _vm._e(),
                  _vm.show_phone == "edit"
                    ? _c("span", { staticClass: "mr-2" }, [
                        _vm._v("Edit Phone Number"),
                      ])
                    : _vm._e(),
                  _vm.show_phone == "list"
                    ? _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.show_phone = "buy"
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v(" mdi-plus ")])],
                        1
                      )
                    : _vm._e(),
                  _vm.show_phone == "list"
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ml-2",
                          attrs: {
                            icon: "",
                            small: "",
                            color: "primary",
                            loading: _vm.phone_numbers.loading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.phone_numbers.fetchPhoneNumbers()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v(" mdi-refresh ")])],
                        1
                      )
                    : _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            small: "",
                            outlined: "",
                            color: "primary",
                          },
                          on: {
                            click: function ($event) {
                              _vm.show_phone = "list"
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v(" mdi-arrow-left ")])],
                        1
                      ),
                ],
                1
              ),
              _vm.show_phone == "list"
                ? _c("v-data-table", {
                    staticClass: "elevation-1",
                    staticStyle: { border: "none" },
                    attrs: {
                      headers: _vm.phone_numbers_headers,
                      items: _vm.phone_numbers.numbers,
                      "items-per-page": 5,
                      loading: _vm.phone_numbers.loading,
                      "loading-text": "Loading...",
                      "single-select": false,
                      "item-key": "sid",
                      "hide-default-footer":
                        _vm.phone_numbers.numbers.length <= 5,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.connected",
                          fn: function ({ item }) {
                            return [
                              _vm.user.twilio.applicationSid ==
                              item.voice_application_sid
                                ? _c(
                                    "v-icon",
                                    { attrs: { color: "success" } },
                                    [_vm._v("mdi-check-circle")]
                                  )
                                : _c(
                                    "v-icon",
                                    { attrs: { color: "warning" } },
                                    [_vm._v("mdi-alert-circle")]
                                  ),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editPhoneNumber(item)
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-pencil")])],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3996994630
                    ),
                  })
                : _vm._e(),
              _vm.show_phone == "edit"
                ? _c(
                    "v-card",
                    {
                      staticClass: "pa-4",
                      attrs: { rounded: "", elevation: "1" },
                    },
                    [
                      _c(
                        "v-card-title",
                        [
                          _vm.editing_friendly_name
                            ? _c("v-text-field", {
                                attrs: {
                                  label: "Phone Number Name",
                                  outlined: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.editing_friendly_name = false
                                                  _vm.phone_numbers.saveFriendlyName(
                                                    _vm.editing_phone_number
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("mdi-check"),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2230214363
                                ),
                                model: {
                                  value: _vm.editing_phone_number.friendly_name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editing_phone_number,
                                      "friendly_name",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editing_phone_number.friendly_name",
                                },
                              })
                            : _c(
                                "span",
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.editing_phone_number.friendly_name
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.editing_friendly_name = true
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("mdi-pencil")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _vm.phoneIsConnected
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    icon: "mdi-check-circle",
                                    color: "success",
                                    text: "",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-black" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.editing_phone_number.phone_number
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" is fully connected."),
                                ]
                              )
                            : _c(
                                "v-alert",
                                {
                                  attrs: {
                                    text: "",
                                    color: "warning",
                                    icon: "mdi-alert-circle",
                                    prominent: "",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { align: "center" } },
                                    [
                                      _c("v-col", { staticClass: "grow" }, [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-black" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.editing_phone_number
                                                  .phone_number
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" is not fully connected. "),
                                      ]),
                                      _c(
                                        "v-col",
                                        { staticClass: "shrink" },
                                        [
                                          !_vm.phoneIsConnected
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    loading:
                                                      _vm.is_connecting_phone_number,
                                                    disabled:
                                                      _vm.is_connecting_phone_number,
                                                    color: "warning",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.connectPhoneNumber,
                                                  },
                                                },
                                                [_vm._v(" Connect ")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                          _c("v-divider"),
                          _c("phone-settings", {
                            attrs: { phoneSid: _vm.editing_phone_number.sid },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.show_phone == "buy"
                ? _c(
                    "v-sheet",
                    {
                      staticClass: "pa-4 mb-4",
                      attrs: { rounded: "", elevation: "1" },
                    },
                    [
                      _c(
                        "v-form",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Area Code",
                                      rules: _vm.areaCodeRules,
                                      "hide-details": false,
                                      outlined: "",
                                    },
                                    model: {
                                      value: _vm.search.area_code,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.search, "area_code", $$v)
                                      },
                                      expression: "search.area_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Contains",
                                      "hide-details": false,
                                      outlined: "",
                                    },
                                    model: {
                                      value: _vm.search.contains,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.search, "contains", $$v)
                                      },
                                      expression: "search.contains",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "secondary",
                                        "x-large": "",
                                        block: "",
                                        elevation: "0",
                                        loading: _vm.phone_numbers_searching,
                                      },
                                      on: { click: _vm.searchPhoneNumbers },
                                    },
                                    [
                                      _c("v-icon", [_vm._v("mdi-magnify")]),
                                      _vm._v(" Search "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.show_phone == "buy" &&
              (_vm.available_phone_numbers.length > 0 ||
                _vm.phone_numbers_searching)
                ? _c("v-data-table", {
                    staticClass: "elevation-1",
                    staticStyle: { border: "none" },
                    attrs: {
                      headers: _vm.available_phone_numbers_headers,
                      items: _vm.available_phone_numbers,
                      "items-per-page": 5,
                      loading: _vm.phone_numbers_searching,
                      "loading-text": "Searching...",
                      "single-select": false,
                      "item-key": "phone_number",
                      "hide-default-footer":
                        _vm.available_phone_numbers.length <= 5,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.locality",
                          fn: function ({ item }) {
                            return [
                              item.locality
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(item.locality) +
                                        ", " +
                                        _vm._s(item.region)
                                    ),
                                  ])
                                : _c("span", [_vm._v(_vm._s(item.region))]),
                            ]
                          },
                        },
                        {
                          key: "item.capabilities.voice",
                          fn: function ({ item }) {
                            return [
                              item.capabilities.voice == true
                                ? _c(
                                    "v-icon",
                                    { attrs: { color: "success" } },
                                    [_vm._v("mdi-check-circle")]
                                  )
                                : _c("v-icon", { attrs: { color: "error" } }, [
                                    _vm._v("mdi-close-circle"),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "item.capabilities.SMS",
                          fn: function ({ item }) {
                            return [
                              item.capabilities.SMS == true
                                ? _c(
                                    "v-icon",
                                    { attrs: { color: "success" } },
                                    [_vm._v("mdi-check-circle")]
                                  )
                                : _c("v-icon", { attrs: { color: "error" } }, [
                                    _vm._v("mdi-close-circle"),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "item.capabilities.MMS",
                          fn: function ({ item }) {
                            return [
                              item.capabilities.MMS == true
                                ? _c(
                                    "v-icon",
                                    { attrs: { color: "success" } },
                                    [_vm._v("mdi-check-circle")]
                                  )
                                : _c("v-icon", { attrs: { color: "error" } }, [
                                    _vm._v("mdi-close-circle"),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-btn",
                                {
                                  attrs: { small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showBuyDialog(item)
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-currency-usd")])],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      644093201
                    ),
                  })
                : _vm._e(),
              _vm.show_no_results
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text-h5 font-weight-bold text-center grey--text darken-2 mt-4",
                    },
                    [_vm._v("No results")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-tab-item",
            { staticClass: "py-8 px-4 settings-tab" },
            [
              _c("div", { staticClass: "text-h6 font-weight-bold mb-6" }, [
                _vm._v("Default Phone Settings"),
              ]),
              _c("p", [
                _vm._v(
                  "These settings will serve as the default settings for all phone numbers unless overridden by custom setting on the individual phone numbers."
                ),
              ]),
              _c("phone-settings"),
            ],
            1
          ),
          _c(
            "v-tab-item",
            { staticClass: "py-8 px-4 settings-tab" },
            [
              _c(
                "div",
                { staticClass: "text-h6 font-weight-bold" },
                [
                  _vm._v("Audio Files "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-2",
                      attrs: { icon: "", color: "primary", small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.user.fetchAudioFiles()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-refresh")])],
                    1
                  ),
                ],
                1
              ),
              _c("audio-files"),
            ],
            1
          ),
        ],
        1
      ),
      _vm.tabs == 0
        ? _c(
            "div",
            { staticClass: "mt-4" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "success",
                    loading: _vm.user.saving_user_settings,
                    disabled: _vm.user.saving_user_settings,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.user.saveUserSettings()
                    },
                  },
                },
                [_vm._v(" Save Twilio Settings ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: { width: "60%", "max-width": "500" },
          model: {
            value: _vm.show_buy_dialog,
            callback: function ($$v) {
              _vm.show_buy_dialog = $$v
            },
            expression: "show_buy_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5" }, [
                _vm._v(
                  " Buy Phone Number " +
                    _vm._s(_vm.selected_available_phone_number.friendly_name) +
                    " "
                ),
              ]),
              _c("v-card-text", [
                _vm._v(" Are you sure you want to buy "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.selected_available_phone_number.friendly_name)
                  ),
                ]),
                _vm._v("? Your twilio account will be charged accordingly. "),
              ]),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.show_buy_dialog = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        loading: _vm.is_buying_phone_number,
                        disabled: _vm.is_buying_phone_number,
                      },
                      on: { click: _vm.buyPhoneNumber },
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-currency-usd")]),
                      _vm._v(" Buy Now "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }